import { differenceInHours, differenceInMinutes, isThisYear } from "date-fns";

let region;

const formatters = {};

const formatter = (key, options) => {
  if (!region) {
    const { locale } = new Intl.DateTimeFormat().resolvedOptions();
    region = new Intl.Locale(locale).maximize().region;
  }
  formatters[key] ||= new Intl.DateTimeFormat(`en-${region}`, options);
  return formatters[key];
};

const day = { day: "2-digit", month: "short" };
const time = { hour: "2-digit", minute: "2-digit" };
const named = zone => (zone ? { timeZoneName: "short" } : {});

export const full = (at, zone) =>
  formatter(`full-${zone}`, { ...day, year: "numeric", ...time, ...named(zone) }).format(at);

export const weekdayTime = (at, zone) =>
  formatter(`weekly-${zone}`, { weekday: "long", ...time, ...named(zone) }).format(at);

const pad = n => String(n).padStart(2, "0");

export const localDayAndTime = at => ({
  day: String(at.getDay()),
  time: `${pad(at.getHours())}:${pad(at.getMinutes())}`,
});

export const compactly = (at, zone) => {
  const now = new Date();
  if (at > now) return full(at, zone);
  const minutes = differenceInMinutes(now, at);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = differenceInHours(now, at);
  if (hours < 24) return `${hours}h ago`;
  return isThisYear(at)
    ? formatter("day", day).format(at)
    : formatter("dayYear", { ...day, year: "numeric" }).format(at);
};
